import styled from 'styled-components';
import { FR, GB } from 'country-flag-icons/react/3x2';

export const FranceFlag = styled(FR)`
    display: flex;
    position: absolute;
    top: 185px;
    left: 80px;
    height: 70px;
    width: 70px;
`;

export const EnglishFlag = styled(GB)`
    display: flex;
    position: absolute;
    top: 185px;
    left: 280px;
    height: 70px;
    width: 70px;
`;
